import { testimonials } from "@/mocks/dramaData";

const values = [
  { icon: "ri-leaf-line", title: "真实优先", desc: "拒绝标题党与蹭流量的低质搬运，优先选用有依据、可核验的信息。" },
  { icon: "ri-eye-off-line", title: "客观中立", desc: "同一事件有多种说法时并列呈现官方口径与多方回应，不预设立场。" },
  { icon: "ri-speed-line", title: "紧跟节奏", desc: "以稳定的更新频率追踪热点，让吃瓜不再「后知后觉」。" },
  { icon: "ri-group-line", title: "友好社区", desc: "把散落的爱好者聚到一起，营造理性、友善、有温度的交流氛围。" },
];

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
            <i className="ri-heart-3-line"></i> 关于我们
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            让每一次吃瓜，都有章法
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            「本月大瓜」是一个专注聚合与盘点文娱热点的资讯平台。我们相信追热点不该是手忙脚乱地到处翻找，
            而应是一站式地从容掌握。因此我们坚持做聚合、做排序、做脉络，把本月最值得关注的大瓜整理得清清楚楚，再交给你。
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <article key={v.title} className="rounded-2xl border border-background-200 bg-background-100/60 p-6 text-center">
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-900">
                <i className={`${v.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-14">
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
            <i className="ri-chat-quote-line text-3xl text-primary-400"></i>
            <h3 className="mt-2 font-heading text-xl font-black text-foreground-950 md:text-2xl">
              追瓜同路人怎么说
            </h3>
          </div>
          <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5">
                <div className="flex gap-0.5 text-secondary-400">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-800">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}